module.exports = __webpack_public_path__ + "img/rand_money.e99f58ca.svg";